import React from "react";
import { Ripple } from "primereact/ripple";
import { Dialog } from 'primereact/dialog';

interface NoteViewModalProps {
    isOpen: boolean;
    onClose: () => void;
    note?: string;
}

const NoteViewModal: React.FC<NoteViewModalProps> = ({ isOpen, onClose, note }) => {
    /* Modal header */
    const modalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Note
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={onClose}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    return (
        <Dialog header={modalHeader} headerClassName="custom_modal_header" dismissableMask
            visible={isOpen} className="custom_modal_dialog modal_dialog_md" onHide={onClose}>
            <div className="custom_modal_body">
                <div className="custom_modal_body">
                    <div className="row">
                        <div className="col-12">
                            <p className="note_text p-sm-3 p-2 mb-0">
                                {note}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default NoteViewModal;